// export const API_URL = "https://infinity-backoffice.com/loginverification_api.php";
// export const API_KEY = "dpS9uf!J#8@yn4jhUfj6";
export const MAILCHIMP_URL = 'https://betero.us14.list-manage.com/subscribe/post?u=c3ad4d9a7c2da7d9afed06c49&id=67c73aea66'
// export const IP_ADDRESS = "";